import { takeLatest, call, select, put } from 'redux-saga/effects';

import { INIT_APP } from 'src/store/view/constants';
import { getSearchParamsKidsCount } from 'src/store/enqueue/selectors';

import { PRIORITY_PRESET_NAMES } from 'src/components/Filters';
import { setFiltersPriorityPresetAction } from './sagaActions';

/* Проверяем все условия для установки приоритета фильтров */
function* prepareFiltersPriority() {
  const hasKids = yield select(getSearchParamsKidsCount);
  if (hasKids) {
    return PRIORITY_PRESET_NAMES.withChild;
  }

  return PRIORITY_PRESET_NAMES.default;
}
/* Записываем название пресета для фильтров в стор */
export function* setFiltersPriorityPreset() {
  const priority = yield call(prepareFiltersPriority);
  yield put(setFiltersPriorityPresetAction(priority));
}

export default function* searchView() {
  yield takeLatest(INIT_APP, setFiltersPriorityPreset);
}
